
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    const _huanjin = this.info && this.info.tradeEnv ? this.info.tradeEnv : null
    let _updatereporttime = dayjs().format('YYYY-MM-DD')
    if (_huanjin && _huanjin.DayTime) {
      _updatereporttime = this.momentTime(_huanjin.DayTime, 1)
    }

    return {
      huanjin: _huanjin,
      updatereporttime: _updatereporttime,
      showall: false,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'jiaoyihuanjing' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('交易环境', this.huanjin)
  },
  methods: {
    show(mark) {
      this.showall = mark
    },
    GetEnvLevel() {
      let strs = ''
      if (!(this.info && this.info.tradeEnv && this.info.tradeEnv.Grade)) {
        return strs
      }
      switch (this.info.tradeEnv.Grade) {
        case 'AAA':
          strs = 'Best'
          break
        case 'AA':
          strs = 'Excellent'
          break
        case 'A':
          strs = 'Good'
          break
        case 'B':
          strs = 'Average'
          break
        case 'C':
          strs = 'Poor'
          break
        case 'D':
          strs = 'Worst'
          break
        default:
          strs = 'Worst'
      }
      return strs
    },
    GetLv(lv) {
      let color = ''
      switch (lv) {
        case 'Perfect':
          color = '#016F54'
          break
        case 'Great':
          color = '#04A187'
          break
        case 'Good':
          color = '#35B389'
          break
        case 'Average':
          color = ''
          break
        case 'Poor':
          color = '#C1373A'
          break
        case 'Worst':
          color = ''
          break
        default:
          color = ''
      }
      return color
    },
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
